/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import { Table, Input, InputNumber, Popconfirm, Form, Typography, Button, DatePicker, Space, Select } from 'antd'
import styles from './LicenseEditableTable.css'
import moment from 'moment'
import TextField from '@material-ui/core/TextField'
import DangerIcon from 'static/images/icons/danger.svg'
import WarningIcon from 'static/images/Warning.svg'
import DeleteIcon from 'static/images/delete.svg'
import Danger from 'static/images/Danger.png'
import CustomModal from 'views/components/Modal/CustomModal'
import { handleAddLicense, fetchLicenseTableInfo, handleDeleteLicense, handleEditLicense } from 'views/state/MyInfoSettings/MyInfoSettingsActions'
import { LICENSE_COVERED_AREAS, LICENSE_COVERED_EU_REGION_COUNTRIES, getRegion } from 'legacy/constants'
import { getYearMonthDateFormat, getDateDiff } from 'common/dateUtils'
import { makeStyles } from '@material-ui/core/styles'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
})

const LicenseEditableTable = ({ viewOnly, me }) => {
  const dispatch = useDispatch()
  const [ form ] = Form.useForm()
  const classes = useStyles()
  const [ data, setData ] = useState([])
  const [ tableEdit, setTableEdit ] = useState(false)
  const [ index, setIndex ] = useState(-1)
  const [ addCell, setAddCell ] = useState(false)
  const [ deleteConfirmationModal, setDeleteConfirmationModal ] = useState(false)
  const [ currentId, setCurrentId ] = useState(null)
  const [ error, setError ] = useState(false)
  const [ isEmptyField, setIsEmptyField ] = useState(false)
  const [ states, setStates ] = useState(null)
  const getLicenseData = useSelector((state => state.myInfoSettings.myInfoSettings.licenseTable && state.myInfoSettings.myInfoSettings.licenseTable[0]))
  const isUsRegion = getRegion() === 'us'
  const coveredRegions = isUsRegion ? LICENSE_COVERED_AREAS : LICENSE_COVERED_EU_REGION_COUNTRIES

  useEffect(() => dispatch(fetchLicenseTableInfo()), [ dispatch ])
  useEffect(() => {
    if (getLicenseData) {
      const keyData = getLicenseData.map(item => ({
        ...item,
        // status: getExpirationStatus(new Date(getYearMonthDateFormat(item.expiryDate)), new Date()) === 'expired' ? 0 : getExpirationStatus(new Date(getYearMonthDateFormat(item.expiryDate)), new Date()) === 'expairy soon' ? 1 : 2,
        status: getYearMonthDateFormat(item.expiryDate, me)
      })).sort((d1, d2) => new Date(d1.status).getTime() - new Date(d2.status).getTime())
      // const sortedData = _.sortBy(keyData, [ 'status' ])
      const sortedArrayData = keyData.map((item, i) => ({
        ...item,
        no: i + 1,
        key: i.toString(),
        expiryDate: getYearMonthDateFormat(item.expiryDate, me),
        isEditable: false,
        added: false,
      }))
      setData(sortedArrayData)
    }
    if (getLicenseData == null) {
      setData([])
    }
  }, [ getLicenseData ])

  useEffect(() => {
    const check = data.every(item => item.licenseType && item.licenseNumber && item.licenseState && item.expiryDate)
    setError(!check)
    if (addCell) {
      handleCheck(data[data.length - 1])
    }
  }, [ addCell, data, handleCheck ])

  function getExpirationStatus(d1, d2) {
    const diffrence = getDateDiff(d1, d2)
    let status = 'ok'
    if (diffrence > 0) {
      status = 'expired'
    } else if (diffrence <= 0 && diffrence >= -90) {
      status = 'expiry soon'
    }
    return status
  }

  const clickedRow = (rowData, i) => {
    if (tableEdit) {
      setIndex(i)
      form.setFieldsValue({
        no: '',
        ...rowData,
      })
    }
  }
  const handleDropdownChangeLicense = (e, record) => {
    const tempData = [ ...data ]
    tempData.map(item => {
      if (item.key === record.key) {
        // eslint-disable-next-line no-param-reassign
        item.licenseType = e
        // eslint-disable-next-line no-param-reassign
        item.isEditable = true
      }
      return item
    })
    setData(tempData)
  }
  const onNumberChange = (e, record) => {
    const tempData = [ ...data ]
    tempData.map(item => {
      if (item.key === record.key) {
        // eslint-disable-next-line no-param-reassign
        item.licenseNumber = e.target.value
        // eslint-disable-next-line no-param-reassign
        item.isEditable = true
      }
      return item
    })
    setData(tempData)
  }

  const handleDropdownChangeState = (e, record) => {
    const tempData = [ ...data ]
    tempData.map(item => {
      if (item.key === record.key) {
        // eslint-disable-next-line no-param-reassign
        item.licenseState = e
        // eslint-disable-next-line no-param-reassign
        item.isEditable = true
      }
      return item
    })
    setData(tempData)
  }

  const handleExpiryDate = (date, record) => {
    const tempData = [ ...data ]
    tempData.map(item => {
      if (item.key === record.key) {
        // eslint-disable-next-line no-param-reassign
        item.expiryDate = getYearMonthDateFormat(date, me)
        // eslint-disable-next-line no-param-reassign
        item.isEditable = true
      }
      return item
    })

    setData(tempData)
  }
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    i,
    children,
    ...restProps
  }) => {
    const getInputNode = fieldType => {
      switch (fieldType) {
      case 'Licensedropdown':
        return (
          <div>
            <Select style={record !== undefined && record.licenseType === '' ? { border: '1px solid #CC3D3F' } : { width: '100%' }} required value={record !== undefined ? record.licenseType : ''} onSelect={e => { handleDropdownChangeLicense(e, record, i) }}>
              <Select.Option value="Medical">Medical</Select.Option>
            </Select>
            {record !== undefined && record.licenseType === '' && <p style={{ color: '#CC3D3F' }} >This field is required.</p>}
          </div>
        )
      case 'Statedropdown':
        return (
          <div>
            <Select required value={record !== undefined ? record.licenseState : ''} style={record !== undefined && record.licenseState === '' ? { border: '1px solid #CC3D3F' } : { width: '100%' }} onSelect={e => { handleDropdownChangeState(e, record, i) }}>
              {coveredRegions.map((e, k) => <Select.Option value={e.code} key={k}>{e.code}</Select.Option>)}
            </Select>
            {record !== undefined && record.licenseState === '' && <p style={{ color: '#CC3D3F' }} >This field is required.</p>}
          </div>
        )
      case 'calenderexpiry':
        return (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              value={new Date(record.expiryDate)}
              onChange={date => { handleExpiryDate(date, record) }}
              format="MM/dd/yyyy"
              style={record.expiryDate === '' || getExpirationStatus(new Date(record.expiryDate), new Date()) === 'expired' ? { border: '1px solid #CC3D3F' } : { border: '1px solid #e9e9e9' }}
              InputProps={{ classes, readOnly: true }}
              error={false}
              helperText={null}
            />
            { record.expiryDate === '' && <p style={{ color: '#CC3D3F' }} >This field is required.</p>}
            {getExpirationStatus(new Date(record.expiryDate), new Date()) === 'expired' && (<p style={{ color: '#CC3D3F' }}>license has expired</p>)}
          </MuiPickersUtilsProvider>
        )
      default:
        return (
          <div>
            <TextField required value={record !== undefined ? record.licenseNumber : ''} onChange={e => onNumberChange(e, record)} type="text" style={record !== undefined && record.licenseNumber === '' ? { border: '1px solid #CC3D3F' } : { border: '1px solid #e9e9e9' }} InputProps={{ classes }} autoFocus={(record !== undefined && record.key === index.toString()) ? 'autoFocus' : '0'} />
            {record !== undefined && record.licenseNumber === '' && <p style={{ color: '#CC3D3F' }} >This field is required.</p>}
          </div>
        )
      }
    }
    const inputNode = getInputNode(inputType)
    const requiredRule = {
      required: true,
      message: 'This field is required.',
      min: 0,
    }
    return (
      <td {...restProps}>
        {editing ? (
          inputType === 'calenderexpiry' || inputType === 'text' ? (
            <Form.Item
              name={dataIndex}
              style={{ margin: 0, position: 'absolute', width: '90%' }}
              autoComplete="off"
              rules={[ requiredRule ]}
            >
              {inputNode}
            </Form.Item>
          ) : (
            <Form.Item
              name={dataIndex}
              autoComplete="off"
              style={{ margin: 0 }}
              rules={[ requiredRule ]}
            >
              {inputNode}
            </Form.Item>
          )
        ) : (
          children
        )}
      </td>
    )
  }

  const edit = record => {
    setAddCell(false)
    setTableEdit(true)
  }
  const handleDelete = key => {
    if (key === undefined) {
      onAddCellCancel()
      setDeleteConfirmationModal(false)
      setStates(null)
      return
    }
    dispatch(handleDeleteLicense(key))
    setDeleteConfirmationModal(false)
    setStates(null)
  }
  const handleAdd = () => {
    setAddCell(true)
    const newData = {
      key: (data.length).toString(),
      no: data.length + 1,
      licenseType: '',
      licenseNumber: '',
      licenseState: '',
      expiryDate: '',
      added: true,
    }
    setData(state => [ ...state, newData ])
    setIsEmptyField(true)
  }
  const ChangeFormat = date => {
    const expiry = new Date(date)
    const milliseconds = expiry.getTime() + 86340000 // (23 * 60 * 60 * 1000) + (59 * 60 * 1000), 23:59
    const d = new Date(milliseconds).setUTCHours(23, 59, 59, 999)
    return new Date(d).toJSON()
  }
  const handleAddSave = () => {
    const AddedRow = data[data.length - 1]
    const PostObject = { ...AddedRow }
    PostObject.expiryDate = ChangeFormat(PostObject.expiryDate)
    PostObject.licenseType = 'Medical'
    const { no, id, ...allarry } = PostObject
    dispatch(handleAddLicense(allarry))
    setIndex(-1)
    form.setFieldsValue({
      no: '',
      licenseType: '',
      licenseNumber: '',
      licenseState: '',
      expiryDate: '',
    })
    setAddCell(false)
  }
  const handleCheck = (row, rowIndex, e) => {
    if (!addCell) {
      return
    }
    // eslint-disable-next-line space-infix-ops
    const isEmpty = Object.keys(row).filter(key => row[key] === null || row[key] === undefined || row[key] === '').length
    if (isEmpty === 0) {
      setIsEmptyField(false)
    }
  }
  const save = allData => {
    const EditedData = allData.filter(item => item.isEditable === true)
    const filteredData = EditedData.map(({ isEditable, key, no, status, ...rest }) => ({
      ...rest,
      expiryDate: ChangeFormat(rest.expiryDate),
    }))
    dispatch(handleEditLicense(filteredData))
    setIndex(-1)
    form.setFieldsValue({
      no: '',
      licenseType: '',
      licenseNumber: '',
      licenseState: '',
      expiryDate: '',
    })
    setTableEdit(false)
  }
  const onDeleteClick = (key, region) => {
    if (region !== undefined) {
      setStates(region)
    }
    setDeleteConfirmationModal(true)
    setCurrentId(key)
  }
  const onAddCellCancel = () => {
    const AfterCanelData = [ ...data ]
    const lastItem = AfterCanelData.pop()
    setData(AfterCanelData)
    setIndex(-1)
    form.setFieldsValue({
      no: '',
      licenseType: '',
      licenseNumber: '',
      licenseState: '',
      expiryDate: '',
    })
    setAddCell(false)
    form.setFieldsValue({
      no: '',
      licenseType: '',
      licenseNumber: '',
      licenseState: '',
      expiryDate: '',
    })
  }
  const columns = [
    {
      title: '#',
      dataIndex: 'no',
      width: '5%',
      editable: false,
    },
    {
      title: 'License Type',
      dataIndex: 'licenseType',
      width: '15%',
      editable: true,
      render: (text, record, i) => {
        const editable = tableEdit
        return tableEdit ? (
          <Select style={{ width: '100%' }} value={text} required onSelect={e => { handleDropdownChangeLicense(e, record, i) }}>
            <Select.Option value="Medical">Medical</Select.Option>
          </Select>
        ) : <span>{text}</span>
      },
    },
    {
      title: 'License Number',
      dataIndex: 'licenseNumber',
      width: '15%',
      editable: true,
      render: (text, record, i) => {
        const editable = tableEdit
        return editable && record.licenseNumber !== '' ? (<TextField value={record.licenseNumber} required onChange={e => onNumberChange(e, record)} type="text" style={{ border: '1px solid #e9e9e9' }} InputProps={{ classes }}/>)
          : (
            <div>
              <span style={{ display: 'block' }}>
                {text}
              </span>
              {record.licenseNumber === '' && tableEdit && (
                <div>
                  <TextField value={text} style={{ border: '1px solid #CC3D3F' }} required id="error" type="text" InputProps={{ classes }}/>
                  <span style={{ color: '#CC3D3F', display: 'block' }}>This field is required.</span>
                </div>
              )
              }
            </div>
          )
      },
    },
    {
      title: isUsRegion ? 'State' : 'Region',
      dataIndex: 'licenseState',
      width: '20%',
      editable: true,
      render: (text, record, i) => {
        const editable = tableEdit
        return tableEdit ? (
          <Select value={text} required style={{ width: '100%' }} onSelect={e => { handleDropdownChangeState(e, record, index) }}>
            {coveredRegions.map(((area, k) => (<Select.Option key={k} value={area.code}>{area.code}</Select.Option>)))}
          </Select>
        ) : <span>{ (coveredRegions.find(e => text === e.code) || {}).code}</span>
      },
    },
    {
      title: 'Expiration Date',
      dataIndex: 'expiryDate',
      width: '20%',
      editable: true,
      render: (text, record, expiryindex) => {
        const editable = getExpirationStatus(new Date(record.expiryDate), new Date())
        const dangerIcon = <span style={{ marginLeft: '50px' }}><DangerIcon /></span>
        const warningIcon = <span style={{ marginLeft: '50px' }}><WarningIcon /></span>
        const tableEdits = tableEdit
        return tableEdits ? (
        // <TextField required  value={changeFormat(text)} onChange={(e)=>{handleExpairyDate(e,record,index)}} type="date"/>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              value={new Date(record.expiryDate)}
              onChange={date => { handleExpiryDate(date, record) }}
              format="MM/dd/yyyy"
              style={getExpirationStatus(new Date(record.expiryDate), new Date()) === 'expired' ? { border: '1px solid #CC3D3F' } : { border: '1px solid #e9e9e9' }}
              InputProps={{ classes, readOnly: true }}
              error={false}
              helperText={null}
            />
            {getExpirationStatus(new Date(record.expiryDate), new Date()) === 'expired' && (<p style={{ color: '#CC3D3F' }}>license has expired</p>)}
          </MuiPickersUtilsProvider>
        ) : (editable === 'expired' || editable === 'expiry soon') && !tableEdit ? (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span >{editable === 'expired' ? 'Expired' : 'Expiring Soon'}</span>
              <span>{editable === 'expired' ? dangerIcon : warningIcon}</span>
            </div>
            <span style={{ display: 'block' }}>
              {getYearMonthDateFormat(text, me)}
            </span>
          </div>
        ) : tableEdit ? (
          <div>
            <span style={{ display: 'block' }}>
              {getYearMonthDateFormat(text, me)}
            </span>
            {record.expiryDate === '' && tableEdit && (
              <div>
                <TextField type="date"/>
                <span style={{ color: '#CC3D3F', display: 'block' }}>This field is required.</span>
              </div>)}
          </div>) : (
          <div>{getYearMonthDateFormat(text, me)}</div>
        )
      },
    },
    {
      title: 'Delete',
      dataIndex: 'Delete',
      hidden: tableEdit,
      onlyview: viewOnly,
      width: '5%',
      render: (noop, record) => {
        const editable = tableEdit
        return !editable && record.added === false ? (
          <span>
            <Typography.Link
              onClick={e => onDeleteClick(record.id, record.licenseState)}
              style={{
                margin: 21,
              }}
            >
              <DeleteIcon/>
            </Typography.Link>
          </span>
        ) : (null)
      },
    },
  ]
  const typeInput = type => {
    switch (type) {
    case 'expiryDate':
      return 'calenderexpiry'
    case 'licenseType':
      return 'Licensedropdown'
    case 'licenseState':
      return 'Statedropdown'
    default:
      return 'text'
    }
  }

  const mergedColumns = columns.filter(item => !item.onlyview).filter(item => !item.hidden).map(col => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: record => ({
        record,
        inputType: typeInput(col.dataIndex),
        dataIndex: col.dataIndex,
        title: col.title,
        editing: addCell ? record.key === (data.length - 1).toString() : tableEdit && record.key === index.toString(),
      }),
    }
  })
  return (
    <React.Fragment>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          onRow={(record, rowIndex) => ({
            onClick: event => clickedRow(record, rowIndex), // click row
            onChange: e => handleCheck(record, rowIndex, e),
          })}
          bordered
          dataSource={data}
          columns={mergedColumns}
          className={styles.licenseTable}
          rowClassName={record => {
            const diffrence = getExpirationStatus(new Date(record.expiryDate), new Date())
            return (diffrence === 'expired' && !tableEdit ? styles.redbackground : diffrence === 'expiry soon' && !tableEdit ? styles.yellowbackground : 'editable-row')
          }}
          pagination={false}
        />
        { !viewOnly && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            {(!tableEdit && !addCell) && (
              <Button
                onClick={e => { edit(data) }}
                type="none"
                style={{
                  marginLeft: 18,
                  marginBottom: 16,
                  marginRight: 17,
                  width: 142,
                  fontSize: 14,
                  height: 40,
                  color: '#142A39',
                  letterSpacing: 0.75,
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',

                }}
              >
                EDIT LICENSE
              </Button>
            )}
            {(!tableEdit && !addCell) && (
              <Button
                onClick={handleAdd}
                type="none"
                style={{
                  marginBottom: 16,
                  width: 142,
                  fontSize: 14,
                  height: 40,
                  color: 'white',
                  backgroundColor: '#142A39',
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  letterSpacing: 0.75,
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',
                }}
              >
                Add license
              </Button>
            )}
            {tableEdit && (
              <Button
                onClick={() => {
                  dispatch(fetchLicenseTableInfo())
                  setTableEdit(false)
                }}
                type="primary"
                style={{
                  marginBottom: 16,
                  fontSize: 14,
                  height: 40,
                  color: 'white',
                  backgroundColor: '#142A39',
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  letterSpacing: 0.75,
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',
                }}
              >
                Cancel
              </Button>
            )}
            {tableEdit && (
              <Button
                onClick={e => save(data)}
                disabled={error}
                type="none"
                style={{
                  marginLeft: 18,
                  marginBottom: 16,
                  marginRight: 17,
                  fontSize: 14,
                  height: 40,
                  color: '#142A39',
                  letterSpacing: 0.75,
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',
                }}
              >
                Save
              </Button>
            )}
            {addCell && (
              <Button
                onClick={e => onAddCellCancel()}
                type="primary"
                style={{
                  marginBottom: 16,
                  fontSize: 14,
                  height: 40,
                  color: 'white',
                  backgroundColor: '#142A39',
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  letterSpacing: 0.75,
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',
                }}
              >
                Cancel
              </Button>
            )}
            {addCell && (
              <Button
                onClick={e => handleAddSave()}
                disabled={error}
                type="none"
                style={{
                  marginLeft: 18,
                  marginBottom: 16,
                  marginRight: 17,
                  fontSize: 14,
                  height: 40,
                  color: '#142A39',
                  letterSpacing: 0.75,
                  borderRadius: 4,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontFamily: 'Work Sans',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
                  textTransform: 'uppercase',
                }}
              >
                Save
              </Button>
            )}
          </div>
        )}
      </Form>
      <CustomModal
        modalType="confirm"
        open={deleteConfirmationModal}
        closeModalHandler={e => setDeleteConfirmationModal(false)}
        icon={Danger}
        iconAltText="Warning Icon"
        heading="Are you sure you want to remove this license?"
        // eslint-disable-next-line no-unneeded-ternary
        descriptionLine1={states ? `If this is the only active license the user has in ${states}, the clinician will lose the ability to` : ''}
        // eslint-disable-next-line no-unneeded-ternary
        descriptionLine2={states ? `provide services in ${states}.` : ''}
        confirmHandler={e => handleDelete(currentId)}
        confirmButtonText="Yes, Delete"
        declineButtonText="CANCEL"
      />
    </React.Fragment>
  )
}

export default LicenseEditableTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/LicenseEditableTable/LicenseEditableTable.jsx